import { render } from "./IotSettings.vue?vue&type=template&id=5218b786&ts=true"
import script from "./IotSettings.vue?vue&type=script&lang=ts"
export * from "./IotSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__